import {ActionTree} from "vuex";
import {AwardsWidgetState} from "@/apps/AwardsWidget/models/awards-widget-state";
import Vue from 'vue';

export default <ActionTree<AwardsWidgetState, AwardsWidgetState>>{
    async onClick(context, category) {
        if (!category) {
            return;
        }

        const isParent = category.categories && category.categories.length > 0;

        if (!isParent) {
            context.commit('setRecipientsLimit', 10);
            context.commit('setSelectedCategory', category);
        }

        context.state.categories.forEach((parent) => {

            const containsSelected =
                parent.categories.indexOf(context.state.selectedCategory) >= 0;

            const shouldBeOpen =
                parent === category || containsSelected;

            parent.selected =
                parent === context.state.selectedCategory ||
                containsSelected;

            Vue.set(parent, 'vuw-open', shouldBeOpen);

            parent.categories.forEach((child) => {
                child.selected =
                    child === context.state.selectedCategory;
            });
        });
    },

    async findInitiallySelectedCategory(context, categories) {
        for (let i = 0; i < categories.length; i++) {
            let item = categories[i];

            if (item.recipients?.length > 0) {
                return item;
            }

            let subItem = context.getters.findInitiallySelectedCategory(item.categories);

            if (subItem) {
                return subItem;
            }
        }
    },

    async init(context, categories) {
        if (!categories || categories.length === 0) {
            return;
        }

        const firstTopLevel = categories[0];

        let categoryToSelect = firstTopLevel;

        if (firstTopLevel.categories && firstTopLevel.categories.length > 0) {
            categoryToSelect = firstTopLevel.categories[0];
        }
        await context.commit('setSelectedCategory', categoryToSelect);

        await context.dispatch('onClick', categoryToSelect);
    }
}
